import EditIcon from "@mui/icons-material/Edit";
import { Grid, Skeleton, Typography } from "@mui/material";
import React from "react";

const UserHeaderSkeleton = () => {
  return (
    <>
      <Grid
        container
        boxShadow={"0px 1px 1px rgba(0,0,0,0.16)"}
        flexDirection={"column"}
        height={"100%"}
      >
        <Grid item padding={"1rem"} height={"9vh"}>
          <Grid
            container
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Grid item sx={{ display: "flex", alignItems: "center" }}>
              <Skeleton
                variant="circular"
                width={50}
                height={50}
                sx={{ marginLeft: "10px" }}
              />
              <Skeleton variant="rectangular" width={50} height={20} />
            </Grid>
            <Grid item>
              <Skeleton variant="rectangular" width={100} height={20} />
            </Grid>
            <Grid item>
              <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                <span
                  style={{
                    color: "#1D4A87",
                    fontSize: "1.1rem",
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  شماره موبایل:
                  <Skeleton variant="rectangular" width={50} height={20} />
                </span>
              </Typography>
            </Grid>
            <Grid item sx={{ display: "flex", alignItems: "center" }}>
              <Skeleton variant="rectangular" width={70} height={20} />

              <span className="seprator_gray"></span>
              <Typography sx={{ cursor: "pointer", color: "#1D4A87" }}>
                <EditIcon sx={{ marginLeft: "5px" }} />
                ویرایش اطلاعات
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          padding={"1rem"}
          item
          sx={{ background: "rgba(154,175,196,0.15)" }}
        >
          <Grid container justifyContent={"center"} alignItems={"center"}>
            <Grid item>
              <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                <span
                  style={{
                    color: "#1D4A87",
                    fontSize: "1.1rem",
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  نوع کاربر:{" "}
                  <Skeleton variant="rectangular" width={70} height={20} />
                </span>
              </Typography>
            </Grid>
            <Grid item sx={{ marginInline: "4vw" }}>
              <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                <span
                  style={{
                    color: "#1D4A87",
                    fontSize: "1.1rem",
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  تاریخ فعالسازی کاربری:{" "}
                  <Skeleton variant="rectangular" width={70} height={20} />
                </span>
              </Typography>
            </Grid>
            <Grid item>
              <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                <span
                  style={{
                    color: "#1D4A87",
                    fontSize: "1.1rem",
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  نام کاربری :{" "}
                  <Skeleton variant="rectangular" width={70} height={20} />
                </span>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default UserHeaderSkeleton;
